window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 2, // ✅ Changed from 3 to 2 for cleaner tablet view
      mobileShow = 1, // ✅ Default to 1 for mobile
      sliderGrid = "column",
      sliderAutoplay = e.dataset.autoplay,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);
    
    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime
      };
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
    } else {
      sliderContainer = false;
    }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 30,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction"
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: { // mobile+
          slidesPerView: mobileShow,
        },
        768: { // tablet+
          slidesPerView: tabletShow, // ✅ Will show 2 on tablets
        },
        1024: { // large desktop+
          slidesPerView: largeDesktopShow,
        },
        1200: { // large desktop+
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    if (!sliderContainer == false && sliderAutoplay == "true") {
      sliderContainer.addEventListener('mouseenter', (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener('mouseleave', (e) => {
        featuredCollection.autoplay.start();
      });
    }
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();
    headerMainMenuSlider = new theme.Sections();

  sections.register("scrolling_bar", theme.scrollingText);
  sections.register("header", theme.headerSection);
  headerMainMenuSlider.register("header", theme.menuProductSlider);
  headerSearchModule.register("header", theme.headerSearch);
  headerCartModule.register("header", theme.CartDrawerActions);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register('accordion', theme.accordion);
  sections.register('blog', theme.blog);
});

// adding read more button on testimonial cards
const wordLimit = 15;
document.querySelectorAll(".single-testimonial-single-item__content p.text").forEach((para) => {
  const fullText = para.innerText;
  const words = fullText.split(" ");

  if (words.length > wordLimit) {
    const shortText = words.slice(0, wordLimit).join(" ") + "...";

    // Create a Read More button
    const btn = document.createElement("div");
    btn.className = "read-more-btn";
    btn.innerText = "Read more";
    btn.style.color = "#EF4657";
    btn.style.textDecoration = "underline";
    btn.style.paddingBottom = "10px";
    btn.style.display = "inline-block";
    btn.style.cursor = "pointer";
    // Replace paragraph text with short text
    para.innerText = shortText;
    para.after(btn);

    // Toggle logic
    btn.addEventListener("click", () => {
      const isShort = para.innerText.endsWith("...");
      para.innerText = isShort ? fullText : shortText;
      btn.innerText = isShort ? "Read less" : "Read more";
    });
  }
});


document.querySelectorAll('.tab-buttons button').forEach(button => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');

      // Update buttons
      document.querySelectorAll('.tab-buttons button').forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Update tab content
      document.querySelectorAll('.tab-content').forEach(content => {
        content.classList.remove('active');
      });
      document.getElementById(tab).classList.add('active');
    });
  });

function applyStyles() {
    const buttonBody = document.querySelector('#button-body');
    const button = document.querySelector('.onlyBubbleLarge #button');
    const svg = document.querySelector('.awesome-iframe #button button i.type1 svg');

    if (buttonBody) {
      buttonBody.style.width = '50px';
      buttonBody.style.height = '50px';
    }

    if (button) {
      button.style.width = '50px';
      button.style.height = '50px';
      button.style.left = '5px';
      button.style.bottom = '39px';
      button.style.position = 'absolute';
    }

    if (svg) {
      svg.style.width = '20px';
      svg.style.height = '20px';
    }
  }

  // Retry every 300ms until elements are found, max 5s
  const maxTries = 5000 / 300;
  let tryCount = 0;
  const interval = setInterval(() => {
    applyStyles();
    tryCount++;
    if (document.querySelector('.awesome-iframe #button-body') || tryCount >= maxTries) {
      clearInterval(interval);
    }
  }, 300);


  document.addEventListener("DOMContentLoaded", function () {
    const scrollLinks = document.querySelectorAll(".scrollToTopLink, .sustanability a.button.button--small, .multiple-tea-cont a.custom-link-button");

    scrollLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
  });

 document.querySelectorAll('a.scroll-link').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const target = document.querySelector(targetId);

      if (target) {
        // Detect mobile screen width (adjust 768px if needed)
        const isMobile = window.innerWidth <= 768;
        const offset = isMobile ? 70 : 200;

        const topPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });
      }
    });
  });


document.addEventListener("DOMContentLoaded", function () {
  function updateInstagramElements() {
    // Update alt attributes for images
    document.querySelectorAll('#stories img').forEach(function (img) {
      if (!img.hasAttribute('alt') || img.alt.trim() === '') {
        let storyName = img.closest('.story')?.querySelector('.name')?.innerText;
        img.alt = storyName
          ? `Instagram story from ${storyName}`
          : "Instagram story image";
      }
    });

    // Add href for Instagram panel links
    document.querySelectorAll('.item-link').forEach(function (link) {
      if (!link.hasAttribute('href') || link.getAttribute('href') === '') {
        link.setAttribute('href', '#!stories');
      }
    });
    document.querySelectorAll('[aria-hidden="true"]').forEach(el => {
      el.removeAttribute('aria-hidden');
    });
  }

  // Run immediately in case content is already loaded
  updateInstagramElements();

  // Watch for changes in the Instagram feed container
  const instaContainer = document.querySelector('#stories') || document.body;
  const observer = new MutationObserver(() => {
    updateInstagramElements();
  });
  observer.observe(instaContainer, { childList: true, subtree: true });
});



// TEA TOUR POPUP

document.addEventListener("DOMContentLoaded", function() {
  const triggers = document.querySelectorAll(".ask-a-question");

  triggers.forEach(trigger => {
    const container = trigger.closest(".custom-button-wrap"); 
    if (!container) return;

    const popup = container.querySelector(".contact-poopup-outer");
    const closeBtn = popup ? popup.querySelector(".popup-close") : null;

    // Open popup
    trigger.addEventListener("click", function(e) {
      e.preventDefault();
      if (popup) popup.classList.add("active");
    });

    // Close popup (X button)
    if (closeBtn) {
      closeBtn.addEventListener("click", function() {
        popup.classList.remove("active");
      });
    }

    // Close when clicking outside popup-inner
    if (popup) {
      popup.addEventListener("click", function(e) {
        if (e.target === popup) {
          popup.classList.remove("active");
        }
      });
    }

    // Close on ESC key
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && popup.classList.contains("active")) {
        popup.classList.remove("active");
      }
    });
  });
});


// Tea tour CTAs are plain links now (see button_link on each tea tour section).
// This function used to POST the 500 dollar deposit to the cart without calling
// preventDefault, so a click both added the deposit AND followed the href. The
// customer landed on the deposit product page with the item already in their
// cart, pressed Add to cart, and ended up with two non-refundable deposits.
// It also swallowed the 422 sold out response and redirected to an empty cart
// once the tenth deposit sold. Kept as a no-op so that any remaining onclick
// attributes stay harmless and the browser simply follows the link.
function addToCartAndOpenCart() {
  return true;
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onClickPrev.bind(this));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onClickNext.bind(this));
      }
    }

    onClickPrev() {
      this.slider.scrollBy({ left: -this.slider.clientWidth, behavior: 'smooth' });
    }

    onClickNext() {
      this.slider.scrollBy({ left: this.slider.clientWidth, behavior: 'smooth' });
    }
  });
}